<template>
  <FormFilter
    v-model="modelFilterFormData"
    @request="onSubmit"
    @reset="onReset"
  >
    <AppInputDate
      title="Дата начала"
      name="start_date"
      type="single"
    />

    <AppInputDate
      title="Дата окончания"
      name="stop_date"
      type="single"
    />

    <VInput
      label="Стройка"
      name="name"
    />

    <VSelect
      label="Руководитель"
      name="director"
      :items="userList"
      :handler-search="GETUserList"
      search
    />

    <VInput
      label="Шифр бух."
      name="accounting_cipher"
    />

    <VInput
      label="Заказ покупателя"
      name="buyer_order"
    />

    <VInput
      label="Стоимость стройки"
      name="price"
    />

    <VInput
      label="Подписано"
      name="signed"
    />

    <VInput
      label="Остаток"
      name="remains"
    />

    <VInput
      label="Город заказчика"
      name="customer_city"
    />
  </FormFilter>
</template>

<script>
import AppInputDate from '@/components/page/input/AppInputDate'
import FormFilter from '@/components/page/Form/FormFilter/FormFilter'
import VInput from '@/components/page/Form/Vinput/Vinput'
import VSelect from '@/components/page/Form/VSelect'

import { MIXIN_FORM_FILTER } from '@/mixins/form/mixinFormFilter'
import { MIXIN_USER_LIST } from '@/mixins/handbook/userList'
import { createModelFilterFormData } from '@/mixins/form/createModelFilterFormData'
import { prepareBuildingRegisterFormData } from '@/utils/page/pto/buildingRegister'

export default {
  name: 'FilterPtoBuildingRegister',
  components: {
    AppInputDate,
    FormFilter,
    VInput,
    VSelect
  },
  mixins: [MIXIN_FORM_FILTER, MIXIN_USER_LIST],

  computed: {
    ...createModelFilterFormData('pto/building')
  },

  methods: {
    onSubmit (data) {
      this.$emit('request', prepareBuildingRegisterFormData(data))
    }
  }
}
</script>
